import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../components/shapes/Line'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModelFooter from './ModelFooter'
import Separator from '../../../components/helpers/Separator'
import ServiceOrdersList from './list/ServiceOrdersList'
import ServiceOrdersLoader from './_load/ServiceOrdersLoader'

const RemoveServiceOrderModal = props => {
  const { t } = useTranslation('common')

  return (
    <ControlledModal width="52rem" {...props}>
      <ServiceOrdersLoader>
        <Title size="h4" noMargin>
          {t('serviceOrders.removeModal.title')}
        </Title>
        <SmallText>{t('serviceOrders.removeModal.description')}</SmallText>

        <Separator weight={6} />
        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={6} />

        <ServiceOrdersList />

        <ModelFooter />
      </ServiceOrdersLoader>
    </ControlledModal>
  )
}

export default RemoveServiceOrderModal
